// Thin web adapter over the shared injectable admin API.
// Same-origin /api/admin/* + cookie credentials + anon/trace headers.

import { createAdminApi, AdminApiError } from '@roomtreatment/api-client';
import { newTraceId, traceLog, TRACE_HEADER } from './traceId';
import { anonId } from './anonId';
import { DEV_TOOLS_BUILD, watchJobFailures } from './devAccount';

export { AdminApiError };

const ANON_HEADER = 'X-Anonymous-Id';

function anonHeader(): Record<string, string> {
  const id = anonId();
  return id ? { [ANON_HEADER]: id } : {};
}

export const adminApi = createAdminApi({
  credentials: 'include',
  // Development builds only: announce failed or credit-refused solves so the
  // dev account can refill its credits (components/dev/DevComputeFailurePrompt).
  // Production gets the plain global fetch.
  fetch: DEV_TOOLS_BUILD ? watchJobFailures((input, init) => globalThis.fetch(input, init)) : undefined,
  getExtraHeaders: anonHeader,
  newTraceId,
  onTrace: traceLog,
  traceHeader: TRACE_HEADER,
});
